module.exports = __webpack_public_path__ + "img/Officebuilding.df432ce2.svg";